import { GYM_STUDIO as C } from "../../lib/gym/gymStudioTheme";

export type GymCountdownPhase = number | "go";

export interface GymCountdownOverlayProps {
  phase: GymCountdownPhase;
}

/** Cuenta regresiva ligera (CSS puro, sin blur ni Framer en el número). */
export function GymCountdownOverlay({ phase }: GymCountdownOverlayProps) {
  const isGo = phase === "go";
  const display = isGo ? "¡Toca!" : String(phase);

  return (
    <div className="absolute inset-0 z-50 flex flex-col items-center justify-center pointer-events-none">
      <div className="absolute inset-0 bg-black/55" aria-hidden />

      <div key={display} className="relative z-10 flex flex-col items-center text-center gym-count-tick">
        <div
          className="relative flex items-center justify-center rounded-full"
          style={{
            width: isGo ? 140 : 120,
            height: isGo ? 140 : 120,
            background: `radial-gradient(circle, ${C.accentGlow} 0%, transparent 70%)`,
          }}
        >
          <span
            className="tabular-nums font-bold leading-none select-none"
            style={{
              fontSize: isGo ? "2.75rem" : "4.5rem",
              fontFamily: "'Playfair Display', Georgia, serif",
              color: isGo ? "#fce7f3" : C.textMain,
              textShadow: `0 0 32px ${C.accentGlow}, 0 4px 20px rgba(0,0,0,0.45)`,
              letterSpacing: isGo ? "0.02em" : "-0.04em",
            }}
          >
            {display}
          </span>
          {!isGo && <span className="absolute inset-0 rounded-full border-2 gym-count-ring" style={{ borderColor: C.accent }} />}
        </div>

        <p
          className="mt-5 text-xs font-medium uppercase tracking-[0.2em]"
          style={{ color: "rgba(245,240,235,0.55)" }}
        >
          {isGo ? "Suena tu guitarra" : "Prepárate"}
        </p>
      </div>

      <style>{`
        .gym-count-tick {
          animation: gymCountPop 0.32s ease-out both;
        }
        .gym-count-ring {
          animation: gymCountRing 0.75s ease-out forwards;
        }
        @keyframes gymCountPop {
          0% { transform: scale(0.82); opacity: 0.4; }
          70% { transform: scale(1.04); opacity: 1; }
          100% { transform: scale(1); opacity: 1; }
        }
        @keyframes gymCountRing {
          0% { transform: scale(0.85); opacity: 0.75; }
          100% { transform: scale(1.35); opacity: 0; }
        }
      `}</style>
    </div>
  );
}
